import Modal from '@/components/Modal';
import React, { useState } from 'react';
import Lottie from 'react-lottie';

import EmergeConnectsToXero from '@/assets/EmergeConnectsToXero.json';
import Button from '@/components/Button';
import { requestXeroConnectionAuthUrl } from '@/services/xero';
import { openLinkInSameTab } from '@/utils/openLinkInSameTab';
import { logAnalyticsEvent } from '@/services/firebase';

interface XeroModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: EmergeConnectsToXero,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

const XeroModal: React.FC<XeroModalProps> = ({ isOpen, onClose }) => {
  const [isConnecting, setIsConnecting] = useState(false);

  const handleXeroLogin = async () => {
    if (isConnecting) {
      return;
    }

    setIsConnecting(true);
    try {
      const response = await requestXeroConnectionAuthUrl();
      openLinkInSameTab(response.data.url);
      logAnalyticsEvent('select_content', {
        content_type: 'button',
        content_id: 'start_xero_connection'
      });
    } finally {
      setIsConnecting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} variant="xxl">
      <div className="flex flex-col gap-y-2 p-3 relative">
        <div className="rounded-lg bg-brand-xero-light-blue h-36 w-full flex flex-row">
          <div className="flex-1"></div>
          <div className="flex flex-2 flex-row items-center justify-center">
            <Lottie options={defaultOptions} />
          </div>
          <div className="flex-1"></div>
        </div>
        <div className="flex flex-col gap-y-8">
          <div className="flex flex-col gap-y-4">
            <h3 className="text-brand-xero-blue text-2xl">Unlock the power of Emerge and Xero</h3>
            <p className="text-dark-navy-30 text-sm font-light">
              To get started, log in to Xero below. This will securely authorise Emerge to access
              Xero.
            </p>
          </div>
          <div className="flex items-center justify-center">
            <Button variant="xero" onClick={handleXeroLogin} disabled={isConnecting}>
              Log in to Xero
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default XeroModal;
